import { useState, useRef, useEffect } from "react";
import { LoadingSpinner } from "@/components/LoadingSpinner";

// Optimized image component with lazy loading and error handling
export default function OptimizedImage({ 
  src, 
  alt, 
  className = "", 
  width = 400,
  onClick,
  priority = false,
  ...props 
}) {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(priority);
  const imgRef = useRef(null);
  
  useEffect(() => {
    if (priority) return;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    
    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
    
    return () => observer.disconnect();
  }, [priority]);
  
  if (hasError || !src) {
    return (
      <div className={`bg-stone-100 flex items-center justify-center ${className}`}>
        <span className="text-stone-400 text-xs text-center px-2">Imagem indisponível</span>
      </div>
    );
  }
  
  return (
    <div ref={imgRef} className={className}>
      {!isLoaded && isInView && (
        <div className="w-full h-full bg-stone-100 animate-pulse flex items-center justify-center min-h-[50px]">
          <LoadingSpinner size={24} />
        </div>
      )}
      {isInView && (
        <img
          src={src}
          alt={alt}
          className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
          onError={() => setHasError(true)}
          onLoad={() => setIsLoaded(true)}
          onClick={onClick}
          {...props}
        />
      )}
    </div>
  );
}

export const optimizeCloudinaryUrl = (url) => url;
